import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { WritBean } from '../../../../beansts/quests/writ.bean';
import {AppDataService} from "../../../../services/app-data.service";
import { CompanyService }  from '../../../../services/company.service';
import { TranslationService } from '../../../../services/translation.service';
declare let $: any;
declare let Swal: any;

@Component({
    selector : 'writ-screen',
    templateUrl:'writ-screen.html'
})
export class WritScreenComponent implements OnInit, OnDestroy{

  public writList=[];
  public writ=null;
  public constructor( private _router : Router,public translate: TranslationService,public _appData : AppDataService,private _companyService : CompanyService) {
  }
  public ngOnInit(): any {
    this._companyService.getAllUserWrits(this._appData.instagramUser).get().then(val=>{
      this.writList=[]
      val.forEach(w=>{
        let wrt=w.data();
        let writBean=new WritBean();
        writBean.setCompanyService(this._companyService)
        writBean.setAppData(this._appData)
        wrt=writBean.calculateJobPoints(wrt)
        this.writList.push(wrt)
      })
    })
  }
  public doSearch(evt){

  }
  public chooseWrit(writ){
    this.writ=writ
  }
  public chooseJob(job){
    if (job.url){
      let link=job.url
      if (link.indexOf('{uid}')){
        link = link.replace('{uid}',this._appData.instagramUser.uid);
      }
      this._appData.cellScreen='iframe'
      this._appData.param=link
    }
    if (job.kind=='check'){
      this._appData.cellScreen='checklist'
      this._appData.param=job
      setTimeout((v)=>{
        $('#checklist-screen-reload').click();
      },1000)
    }
  }

  public ngOnDestroy() : any {
  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/cellphone-modal/writ-screen/writ-screen.ts